import { FC } from 'react'

import Scratch from 'pages/scratch/Scratch'
import { Panels } from 'peach/components'
import { Switch, Route, Redirect } from 'peach/router'

import { useIsSessionActive } from 'core/auth/authStore'

import AppController from './AppController'
import LoginModal from './auth/LoginModal'
import AppHeader from './Header/AppHeader'
import UnauthenticatedRoutes, {
  UNAUTHENTICATED_ROUTES,
} from './UnauthenticatedRoutes'

const AuthRoutesController: FC = () => {
  const isSessionActive = useIsSessionActive()

  return (
    <Panels header={<AppHeader />}>
      <Switch>
        <Route path='/scratch'>
          <Scratch />
        </Route>

        <Route>
          <Switch>
            <Route path={UNAUTHENTICATED_ROUTES}>
              <UnauthenticatedRoutes />
            </Route>
            <Route
              render={() => {
                if (isSessionActive) {
                  return <AppController />
                }
                return <Redirect to='/environments' />
              }}
            />
          </Switch>
        </Route>
      </Switch>
      <LoginModal />
    </Panels>
  )
}

export default AuthRoutesController
